class SilkSleepMasks extends HTMLElement {
	constructor() {
		super();
		this.init();
	}

	init() {
		// Event listeners voor responsive gedrag
		this.handleResize();
		window.addEventListener('resize', this.handleResize.bind(this));
		
		// Smooth scroll voor buttons
		this.initSmoothScroll();
		
		// Accessibility verbeteringen
		this.initAccessibility();
	}

	handleResize() {
		// Responsive gedrag wordt nu gedaan via CSS
		// Dit kan uitgebreid worden voor meer complexe responsive gedrag
	}

	initSmoothScroll() {
		const buttons = this.querySelectorAll('.silk-sleep-masks__btn');
		buttons.forEach(button => {
			button.addEventListener('click', (e) => {
				// Voeg smooth scroll toe als de link naar een sectie op dezelfde pagina verwijst
				const href = button.getAttribute('href');
				if (href && href.startsWith('#')) {
					e.preventDefault();
					const target = document.querySelector(href);
					if (target) {
						target.scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						});
					}
				}
			});
		});
	}

	initAccessibility() {
		// Voeg ARIA labels toe voor betere toegankelijkheid
		const card = this.querySelector('.silk-sleep-masks__card');
		if (card) {
			card.setAttribute('aria-label', 'Silk Sleep Masks product showcase');
		}
	}
}

// Registreer de custom element
customElements.define('silk-sleep-masks', SilkSleepMasks);
